<div fxLayout="column" fxLayoutGap="30px">
  <span fxLayout="row" fxLayoutAlign="center center" class="confirmation" ngStyle.xs="font-size:20px">
    {{'confirmation' | transloco}}</span>
  <span fxLayout="column" fxLayoutGap="30px">
    <span fxFlex fxLayout="row" class="changes-saved-success" fxLayoutAlign="center center"
      ngStyle.xs="font-size:12px;padding-top:2px;padding-bottom:10px">{{'changes_saved_successfully' | transloco}}</span>

    <div fxLayout="column" fxLayoutAlign="center center">
      <span fxLayout="row">
        <div fxFlex fxLayoutAlign="center center">
          <button style="color: #FFFFFF;text-decoration: underline;cursor: pointer; background-color: #0014DC;" color="primary" ngStyle.xs="width:100px;font-size:15px;height:35px" mat-stroked-button
            class="ok-button medium" (click)="ok()">{{'ok' | transloco}}</button>
        </div>
      </span>
    </div>
  </span>

</div>
